import {throttle} from "lodash";

export const useResizeHandler = onResize => {
    const throttledOnResize = throttle(onResize, 100);
    window.addEventListener("resize", throttledOnResize);
    return () => {
        window.removeEventListener("resize", throttledOnResize);
    };
};
